// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Ensure all form controls have same height */
.form-control, 
.ant-select:not(.ant-select-customize-input) .ant-select-selector,
.ant-picker {
    height: 40px !important;
    line-height: 40px !important;
}

/* Textarea should maintain its own height */
.ant-input-textarea {
    height: auto !important;
}

/* Three column layout for form rows */
.form-wrapper .row {
    display: flex;
    flex-wrap: wrap;
    margin: 0 -10px;
}

.form-wrapper .row > [class*="col-"] {
    padding: 0 10px;
    margin-bottom: 1rem;
}

/* User type selector should span full width */
.form-wrapper .row > .col-lg-12:first-child {
    flex: 0 0 100%;
    max-width: 100%;
}

/* Standard three column layout */
.form-wrapper .row > .col-lg-4 {
    flex: 0 0 33.333333%;
    max-width: 33.333333%;
}

.form-wrapper .row > .col-lg-6 {
    flex: 0 0 50%;
    max-width: 50%;
}

.form-wrapper .row > .col-lg-12 {
    flex: 0 0 100%;
    max-width: 100%;
}

/* Make form groups fill their containers */
.form-wrapper .form-group {
    width: 100%;
    margin-bottom: 1rem;
}

/* Ensure all form controls fill their containers */
.form-wrapper .form-control,
.form-wrapper .ant-select,
.form-wrapper .ant-picker {
    width: 100%;
}

/* Responsive adjustments */
@media (max-width: 992px) {
    .form-wrapper .row > .col-lg-4,
    .form-wrapper .row > .col-lg-6 {
        flex: 0 0 100%;
        max-width: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/assets/css/register.css"],"names":[],"mappings":"AAAA,8CAA8C;AAC9C;;;IAGI,uBAAuB;IACvB,4BAA4B;AAChC;;AAEA,4CAA4C;AAC5C;IACI,uBAAuB;AAC3B;;AAEA,sCAAsC;AACtC;IACI,aAAa;IACb,eAAe;IACf,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,mBAAmB;AACvB;;AAEA,8CAA8C;AAC9C;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,iCAAiC;AACjC;IACI,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA,2CAA2C;AAC3C;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;;;IAGI,WAAW;AACf;;AAEA,2BAA2B;AAC3B;IACI;;QAEI,cAAc;QACd,eAAe;IACnB;AACJ","sourcesContent":["/* Ensure all form controls have same height */\n.form-control, \n.ant-select:not(.ant-select-customize-input) .ant-select-selector,\n.ant-picker {\n    height: 40px !important;\n    line-height: 40px !important;\n}\n\n/* Textarea should maintain its own height */\n.ant-input-textarea {\n    height: auto !important;\n}\n\n/* Three column layout for form rows */\n.form-wrapper .row {\n    display: flex;\n    flex-wrap: wrap;\n    margin: 0 -10px;\n}\n\n.form-wrapper .row > [class*=\"col-\"] {\n    padding: 0 10px;\n    margin-bottom: 1rem;\n}\n\n/* User type selector should span full width */\n.form-wrapper .row > .col-lg-12:first-child {\n    flex: 0 0 100%;\n    max-width: 100%;\n}\n\n/* Standard three column layout */\n.form-wrapper .row > .col-lg-4 {\n    flex: 0 0 33.333333%;\n    max-width: 33.333333%;\n}\n\n.form-wrapper .row > .col-lg-6 {\n    flex: 0 0 50%;\n    max-width: 50%;\n}\n\n.form-wrapper .row > .col-lg-12 {\n    flex: 0 0 100%;\n    max-width: 100%;\n}\n\n/* Make form groups fill their containers */\n.form-wrapper .form-group {\n    width: 100%;\n    margin-bottom: 1rem;\n}\n\n/* Ensure all form controls fill their containers */\n.form-wrapper .form-control,\n.form-wrapper .ant-select,\n.form-wrapper .ant-picker {\n    width: 100%;\n}\n\n/* Responsive adjustments */\n@media (max-width: 992px) {\n    .form-wrapper .row > .col-lg-4,\n    .form-wrapper .row > .col-lg-6 {\n        flex: 0 0 100%;\n        max-width: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
